import {
  AppsPort,
  BroadcastPort,
  CONSENT_CHANGED_BROADCAST_EVENT,
  ConsentBannerVisibilityPort,
  LoggingPort,
} from '../../ports'

export class ShowConsentBannerUseCase {
  constructor(
    private readonly visibilityPort: ConsentBannerVisibilityPort,
    private readonly appsPort: AppsPort,
    private readonly logging: LoggingPort,
    private readonly broadcaster: BroadcastPort
  ) {}

  hideInitial() {
    this.visibilityPort.hideConsentBanner()
  }

  async run() {
    if (!this.appsPort.isApp()) {
      this.initForWeb()
      return
    }
    /*                  */
    try {
      if ((await this.appsPort.apps()).shouldShowWebCookieBanner()) {
        this.visibilityPort.showConsentBanner()
      }
    } catch (e) {
      const error = new Error('error using apps adapter, keep banner hidden', {
        cause: e,
      })
      this.logging.error(error)
    }
  }

  private initForWeb() {
    if (this.visibilityPort.shouldShowConsentBanner()) {
      this.visibilityPort.showConsentBanner()
    }
    this.broadcaster.receive(CONSENT_CHANGED_BROADCAST_EVENT, () =>
      this.visibilityPort.hideConsentBanner()
    )
  }
}
